"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueryString = void 0;
const utils_1 = require("@hivebrite/utils");
const useReactDomQueryString_1 = require("./useReactDomQueryString");
let useNextQueryStringHook = null;
try {
    // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
    const { useNextQueryString } = require('./useNextQueryString');
    useNextQueryStringHook = useNextQueryString;
}
catch (_a) {
    // next/navigation is not available in this environment
}
const useQueryString = (options) => {
    if ((0, utils_1.isNextJS)() && useNextQueryStringHook) {
        return useNextQueryStringHook(options);
    }
    return (0, useReactDomQueryString_1.useReactDomQueryString)(options);
};
exports.useQueryString = useQueryString;
//# sourceMappingURL=useQueryString.js.map